import { Store } from 'rc-field-form/lib/interface'
import React, { useCallback } from 'react'
import { useAsyncFn } from 'react-use'
import {
  SubmitFeedback,
  Form,
  FormButton,
  HStack,
  StretchDiv,
  VStack,
} from 'admin-web-ui'
import { ChangePasswordFields } from '../../components/Form'
import { ChangePasswordFieldsData } from '../../components/Form/ChangePasswordFields'

interface Props {
  onSubmit: (newPassword: string) => Promise<void>
  onCancel: () => void
}

interface FormData extends ChangePasswordFieldsData {}

export const SetPasswordForm = (props: Props): React.ReactElement => {
  const { onSubmit } = props

  const [submitState, submit] = useAsyncFn(
    async (store?: Store): Promise<void> => {
      const data = store as FormData

      if (!data) {
        return undefined
      }

      await onSubmit(data.newPassword)
    },
    [onSubmit],
  )

  const clearSubmitError = useCallback(() => {
    if (submitState.error) {
      submit(undefined)
    }
  }, [submitState, submit])

  return (
    <Form onFinish={submit} onFieldsChange={clearSubmitError}>
      <VStack>
        <StretchDiv>
          <ChangePasswordFields submitFailure={!!submitState.error} />
          <SubmitFeedback type="error" show={!!submitState.error}>
            There was a problem setting your password. Please try again.
          </SubmitFeedback>
        </StretchDiv>

        <HStack align="center">
          <FormButton onClick={props.onCancel}>Cancel</FormButton>
          <FormButton.Submit loading={submitState.loading}>
            Save
          </FormButton.Submit>
        </HStack>
      </VStack>
    </Form>
  )
}
